import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import OVERLAYS from '@constants/overlays';
import { SentimentSatisfiedIcon } from '@icons';

import IconPopover from '../../IconPopover';
import ActionsContent from './ActionsContent';
import { ActionsTabs } from './interfaces';
import {
  useClientSpecificDashboardButtonDisabled,
  useClientSpecificEmojisVisibility,
  useClientSpecificReactionsVisibility,
} from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';

const Actions = () => {
  const { isEmojisEnabled } = useClientSpecificEmojisVisibility();
  const { isReactionsEnabled } = useClientSpecificReactionsVisibility();

  const initialTab = isEmojisEnabled ? ActionsTabs.Emojis : ActionsTabs.Reactions;
  const [activeTab, setActiveTab] = useState<ActionsTabs>(initialTab);

  const { t: translate } = useTranslation();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.ACTIONS_BUTTON,
  );

  const handleChangeTab = (_: SyntheticEvent, value: string) => {
    setActiveTab(value as ActionsTabs);
  };

  if (!isEmojisEnabled && !isReactionsEnabled) {
    return null;
  }

  return (
    <IconPopover
      icon={<SentimentSatisfiedIcon />}
      label={translate('actions.actions')}
      position={{
        vertical: isMobileOnly ? 'top' : 'bottom',
        horizontal: 'right',
      }}
      analyticsName="actions"
      overlayName={OVERLAYS.ACTIONS}
      disabled={isDisabledClientSpecific}
    >
      {({ onClose }) => (
        <ActionsContent
          activeTab={activeTab}
          onChangeTab={handleChangeTab}
          onClose={onClose}
          isEmojisEnabled={isEmojisEnabled}
          isReactionsEnabled={isReactionsEnabled}
        />
      )}
    </IconPopover>
  );
};

export default Actions;
